// https://stackoverflow.com/questions/41739837/all-mime-types-supported-by-mediarecorder-in-firefox-and-chrome
export default function getSupportedMediaType(media) {
  const types = {
    video: ['webm', 'mp4', 'ogg', 'x-matroska'],
    audio: ['webm', 'mp3', 'ogg', 'x-matroska', 'wav'],
  };

  const codecs = ['vp9,opus', 'vp9', 'vp9.0', 'vp8,opus', 'vp8', 'vp8.0', 'opus', 'avc1', 'av1', 'h265', 'h.265', 'h264', 'h.264', 'pcm', 'aac', 'mpeg', 'mp4a'];

  const isSupported = MediaRecorder.isTypeSupported;

  const supported = [];

  types[media].forEach((type) => {
    const mimeType = `${media}/${type}`;

    codecs.forEach((codec) => [
      `${mimeType};codecs=${codec}`,
      `${mimeType};codecs:${codec}`,
      `${mimeType};codecs=${codec.toUpperCase()}`,
      `${mimeType};codecs:${codec.toUpperCase()}`,
      mimeType,
    ].forEach((variation) => {
      if (isSupported(variation)) supported.push(variation);
    }));
  });

  return supported[0];
}
